module.exports = __webpack_public_path__ + "img/mifi-banner.2e7bae9c.png";